import { useQuery } from '@tanstack/react-query'
import { useTypedApiClient } from 'hooks/useTypedApiClient'

export const useGetPatronBadgeCountsByBadgeId = ({ id }: { id: number }) => {
  const get = useTypedApiClient({
    path: '/le-connect/badgerewards/badge-counts/{id}',
    method: 'get',
  })
  return useQuery({
    queryKey: ['/le-connect/badgerewards/badge-counts', id],
    queryFn: async () => {
      const { data } = await get({ id })
      return data
    },
  })
}
